<template>
    <div id="entrepreneur">
        <section class="probootstrap-half">
            <div class="image-wrap"  data-aos="fade-up" data-aos-duration="1200">
                <div class="image" style="background-image: url(img/slider_7.svg); background-color: #2edee7; "></div>
            </div>
            <div class="text" data-aos="fade-up" data-aos-duration="1200">
                <p class="mb10 subtitle">בדרך לאקזיט עוצרים ב Productive Labs</p>
                <h3 class="mt0 mb40">רגע, אתם בכלל יזמים? למה לא אמרתם קודם?</h3>
                <p>לפני הכל, אנחנו יזמים. כבר כ"כ הרבה שנים אנו מתעסקים קודם כל ב<span class="font-weight-bold">להפוך רעיון והמון אמביציה - לסטאראטפ מצליח</span>.</p>
                <p class="mb50">אנחנו מבינים ללבכם, אין מכעיס מהסיטואציה בה יש לכם כמעט הכל: רעיון, צוות ואש בעיניים, אך מולכם עומדת המשוחה הטכנית של פיתוח המוצר. בדיוק כאן אנו נכנסים,  <span class="font-weight-bold">כדי להציע לאנשים כמונו שירות מקיף שיאפשר להם להתקדם לשלב הבא</span> במיזם ולהגשים חלום!</p>
                <p class="mb50">ליזמים שבנינו אנחנו מציעים שירות הכולל כל עזרה טכנית אותה אתם צריכים כדי <span class="font-weight-bold">להרים מוצר MVP ולרוץ לשוק</span>: מאפיון מוצר, דרך פיתוח המערכת עליה חלמתם ועיצוב לוגו ועד עזרה בניהול תכנית עסקית, אסטרטגית ושיווקית והכל <span class="font-weight-bold">עם המון אהבה ורצון!</span></p>
                <p><button name="contact-us" v-scroll-to="'#contact-us'" class="btn mb10 to-contact">ליצירת קשר</button></p>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data (){
            return{
                mobile: window.matchMedia("(max-width:767px)").matches,
            }
        },
        name: 'entrepreneur',
    }
</script>

<style lang="css" scoped>
    .probootstrap-half {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .probootstrap-half .image-wrap {
        overflow: hidden;
    }
    .probootstrap-half .image-wrap, .probootstrap-half .text {
        width: 50%;
    }
    .probootstrap-half .image {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        -webkit-transition: .8s all ease-in-out;
        transition: .8s all ease-in-out;
        background-color: #f4bd00;
    }
    .probootstrap-half .text {
        padding: 100px;
        background: #f8f8f8;
    }
    .probootstrap-half .text .subtitle {
        color: #000;
        text-transform: uppercase;
    }
    .probootstrap-half .text p {
        font-size: 18px;
        color: #888;
        line-height: 1.5;
    }
    .mb10 {
        margin-bottom: 10px!important;
    }
    button.to-contact {
        background: #bf35d0;
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
    }
    .probootstrap-half .text h3 {
        line-height: 30px;
        font-size: 30px;
        margin-bottom: 30px;
        text-transform: uppercase;
        font-weight: 700;
    }
    @media screen and (max-width: 1000px) {
        .probootstrap-half .image-wrap {
            height: 400px;
            width: 100%;
        }
        .probootstrap-half .text {
            width: 100%;
            padding: 30px 15px;
            float: left;
        }
        .probootstrap-half .text h3 {
            font-size: 24px;
            line-height: 24px;
        }
    }
    .straightDown{
        margin-bottom: -30px;
        margin-top: 30px;
    }
    .straightUp{
        margin-bottom: 30px;
        margin-top: -30px;
    }
</style>
